import { routes as nestedRoutes } from './prop-rentals'

export const routes = {
  ...nestedRoutes,
}
